import { StyleSheet } from '@react-pdf/renderer';
import { PDF_FONT_FAMILY } from './pdf-font';

export const styles = StyleSheet.create({
  page: {
    paddingTop: 72,
    paddingRight: 56,
    paddingBottom: 88,
    paddingLeft: 56,
    backgroundColor: '#ffffff',
    color: '#101828',
    fontFamily: PDF_FONT_FAMILY,
    fontSize: 11,
    lineHeight: 1.5,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 32,
  },
  logo: {
    alignSelf: 'flex-start',
  },
  exportDate: {
    fontSize: 10,
    color: '#475467',
  },
  section: {
    marginBottom: 24,
  },
  sectionDivider: {
    borderBottomWidth: 1,
    borderBottomColor: '#d0d5dd',
    marginBottom: 24,
  },
  h1: {
    fontSize: 22,
    fontWeight: 700,
    marginBottom: 20,
  },
  h2: {
    fontSize: 16,
    fontWeight: 700,
    marginTop: 4,
    marginBottom: 12,
  },
  h3: {
    fontSize: 12,
    fontWeight: 700,
    marginTop: 12,
    marginBottom: 10,
  },
  paragraph: {
    marginBottom: 12,
    fontSize: 11,
    lineHeight: 1.5,
  },
  listItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 6,
  },
  listBullet: {
    width: 12,
    fontSize: 11,
    lineHeight: 1.5,
  },
  listText: {
    flex: 1,
    fontSize: 11,
    lineHeight: 1.5,
  },
  blockquote: {
    borderLeftWidth: 4,
    borderLeftColor: '#d0d5dd',
    paddingLeft: 12,
    marginBottom: 12,
  },
  blockquoteText: {
    color: '#344054',
    fontSize: 11,
    lineHeight: 1.5,
  },
  image: {
    maxWidth: '100%',
    maxHeight: 260,
    objectFit: 'contain',
    alignSelf: 'flex-start',
    marginBottom: 12,
  },
  link: {
    color: '#175cd3',
    textDecoration: 'underline',
  },
  inlineCode: {
    fontFamily: PDF_FONT_FAMILY,
    fontSize: 10,
    backgroundColor: '#f2f4f7',
  },
  strong: {
    fontWeight: 700,
  },
  emphasis: {
    fontStyle: 'italic',
  },
  emptyState: {
    fontStyle: 'italic',
    color: '#475467',
    fontSize: 11,
  },
});
